







































import Vue from 'vue'
import { oneOf } from '@/utils/helper'

export default Vue.extend({
  props: {
    text: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'plus',
      validator: oneOf(['plus', 'blank', 'modal', 'uchinoko', 'moovin', 'spotlight'])
    },
    color: {
      type: String,
      default: 'black',
      validator: oneOf(['black', 'orange'])
    },
    showUnderLine: {
      type: Boolean,
      default: false
    },
    to: {
      type: String,
      default: ''
    }
  },
  computed: {
    typeClassName(): string {
      return `-${this.type}`
    }
  },
  methods: {
    handleClick() {
      this.$emit('click')
    }
  }
})
